import { render, staticRenderFns } from "./baseConfirm.vue?vue&type=template&id=6fb0a40d&scoped=true"
import script from "./baseConfirm.vue?vue&type=script&lang=js"
export * from "./baseConfirm.vue?vue&type=script&lang=js"
import style0 from "./baseConfirm.vue?vue&type=style&index=0&id=6fb0a40d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0a40d",
  null
  
)

export default component.exports